import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('sesiona_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('sesiona_token');
      localStorage.removeItem('sesiona_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = async (email, password) => {
  const response = await api.post('/auth/login', { email, password });
  return response.data;
};

export const getCurrentUser = async () => {
  const response = await api.get('/auth/me');
  return response.data;
};

// Admin - Coaches
export const getCoaches = async () => {
  const response = await api.get('/admin/coaches');
  return response.data;
};

export const createCoach = async (coachData) => {
  const response = await api.post('/admin/coaches', coachData);
  return response.data;
};

export const deleteCoach = async (coachId) => {
  const response = await api.delete(`/admin/coaches/${coachId}`);
  return response.data;
};

// Coachees
export const getCoachees = async () => {
  const response = await api.get('/coachees');
  return response.data;
};

export const getCoachee = async (coacheeId) => {
  const response = await api.get(`/coachees/${coacheeId}`);
  return response.data;
};

export const createCoachee = async (coacheeData) => {
  const response = await api.post('/coachees', coacheeData);
  return response.data;
};

export const updateCoachee = async (coacheeId, coacheeData) => {
  const response = await api.put(`/coachees/${coacheeId}`, coacheeData);
  return response.data;
};

export const deleteCoachee = async (coacheeId) => {
  const response = await api.delete(`/coachees/${coacheeId}`);
  return response.data;
};

// Sessions
export const getSessions = async (coacheeId) => {
  const response = await api.get(`/coachees/${coacheeId}/sessions`);
  return response.data;
};

export const getSession = async (coacheeId, sessionId) => {
  const response = await api.get(`/coachees/${coacheeId}/sessions/${sessionId}`);
  return response.data;
};

export const createSession = async (coacheeId, sessionData) => {
  const response = await api.post(`/coachees/${coacheeId}/sessions`, sessionData);
  return response.data;
};

export const updateSession = async (coacheeId, sessionId, sessionData) => {
  const response = await api.put(`/coachees/${coacheeId}/sessions/${sessionId}`, sessionData);
  return response.data;
};

export const deleteSession = async (coacheeId, sessionId) => {
  const response = await api.delete(`/coachees/${coacheeId}/sessions/${sessionId}`);
  return response.data;
};

// Documents (Google Drive)
export const getDocuments = async () => {
  const response = await api.get('/documents');
  return response.data;
};

// Activity
export const getRecentActivity = async () => {
  const response = await api.get('/activity');
  return response.data;
};

export default api;
